
  //Slick slider
$(document).ready(function(){
	$('.testimonials_wrapper').slick({
		slidesToShow: 3,
		autoplay:true,
		centerMode: false,
		arrows:false,
		responsive: [{
			breakpoint: 992,
			settings: {
			  slidesToShow: 1,
			  slidesToScroll: 1,
			  centerMode: false,
			}
		  }]
	});
 });

//fancy box
$(document).ready(function() {
// 	$(".youtube-video").fancybox();
     $(".youtube-video").fancybox({
        helpers: {
            media: true,
        },
        youtube: {
            autoplay: 1, // enable autoplay
            start: 7 // set start time in seconds (embed)
        }
    }); // fancybox
    $(".youtube-video2").fancybox({
        helpers: {
            media: true,
        },
        youtube: {
            autoplay: 1, // enable autoplay
            //start: 7 // set start time in seconds (embed)
        }
    }); // fancybox
  $('[data-fancybox="email-card"]').fancybox({

		// Change gallery item transition effect
		transitionEffect : 'slide',
	});
});
  
  
//scroll to location
var sl = window.matchMedia( "(min-width: 768px)" );
if (sl.matches) {
    jQuery(document).ready(function($) {
	$(".scrollTo").click(function(event){		
	  //event.preventDefault();
	  $('html,body').animate({scrollTop:$(this.hash).offset().top-100}, 500);
	});
	});
}
else {
    jQuery(document).ready(function($) {
	$(".scrollTo").click(function(event){		
	  //event.preventDefault();
	  $('html,body').animate({scrollTop:$(this.hash).offset().top -5}, 500);
	});
	});
}
  
//sticky menu
$(window).on('scroll', function() {
							
	/*----------------------------------------------------*/
	/*	Navigtion Menu Scroll
	/*----------------------------------------------------*/	
	
	var b = jQuery(window).scrollTop();
	
	if( b > 100 ){		
		jQuery(".site-header").addClass("scroll");
	} else {
		jQuery(".site-header").removeClass("scroll");
	}				

});







